import { useRoutes } from "react-router-dom";

// routes
import MainRoutes from "./MainRoutes";
import SalesRoute from "./SalesRoute";
import PurchaseRoute from "./PurchaseRoute";
// import Others from './Others';
import PrinterRoutes from "./PrinterRoutes";
import OrderRoute from "./OrderRoute";
import WarehouseTransferRoute from "./WarehouseTransferRoute";
import { CommonPrivFilter } from "utils/Privileges";
import Error from "views/others/Error";
import { useState } from "react";
import axios from "axios";
import { baseUrl, redirectUrl } from "config";
import { useEffect } from "react";
import SessionExpire from "utils/SessionExpire";

// ==============================|| ROUTING RENDER ||============================== //
export default function ThemeRoutes() {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    checkSession();
  }, []);

  const checkSession = async () => {
    try {
      const res = await axios.get(baseUrl + "/validateSession", {
        withCredentials: true,
      });
      console.log(res?.data);
    } catch (error) {
      if (error.response?.status === 440) {
        setOpen(true);

        setTimeout(() => {
          redirectUrl();
        }, 5000);
      }
    }
  };

  function filterRoutes(routes) {
  
    const predicate = (route) =>
      !route?.ref ? true : CommonPrivFilter(route.ref)?.canRead;
    // Check if current route passes the predicate
    const matches = predicate(routes);

    // Recursively filter children if they exist
    let filteredChildren = [];
    if (routes.children?.length > 0 && Array.isArray(routes.children)) {
      filteredChildren = routes.children
        .map((child) => filterRoutes(child))
        .filter(Boolean);
    }

    // Return route if it matches or has matching children
    if (matches && filteredChildren.length > 0) {
      return {
        ...routes,
        children: filteredChildren,
      };
    } else if (matches) {
      return routes;
    }

    // Otherwise exclude the route
    return {
      ...routes,
      element: <Error />,
      children: filteredChildren.length > 0 ? filteredChildren : null,
    };
  }

  const routes = [
    filterRoutes(MainRoutes),
    filterRoutes(SalesRoute),
    filterRoutes(PurchaseRoute),
    filterRoutes(PrinterRoutes),
    filterRoutes(OrderRoute),
    filterRoutes(WarehouseTransferRoute),
  ];

  return (
    <>
      {useRoutes(routes)}
      <SessionExpire open={open} />
    </>
  );
}
